// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"d7148f64","404":"7769caee","498":"75d02b42","787":"b68cb3d8"}[chunkId] + ".chunk.js";
};